import type {Branded} from '@kapitalist/utils/Branded'
import {brand} from '@kapitalist/utils/Branded'

/** A `games.id` — a UUIDv7 DB-minted when a game is created. */
export type TGameId = Branded<string, typeof gameIdBrand>
export const mkGameId = (gameId: string): TGameId => brand<TGameId>(gameId)
declare const gameIdBrand: unique symbol

/** A `players.id` — a UUIDv7 DB-minted when a player signs up. */
export type TPlayerId = Branded<string, typeof playerIdBrand>
export const mkPlayerId = (playerId: string): TPlayerId => brand<TPlayerId>(playerId)
declare const playerIdBrand: unique symbol

/** A `signup_requests.id` — a UUIDv7 DB-minted when someone requests an account. */
export type TSignupRequestId = Branded<string, typeof signupRequestIdBrand>
export const mkSignupRequestId = (signupRequestId: string): TSignupRequestId =>
  brand<TSignupRequestId>(signupRequestId)
declare const signupRequestIdBrand: unique symbol

/**
 * A portfolio neighborhood's id — the group a player's same-color properties sit in. Minted by
 * the engine (opaque, never reused).
 */
export type TPortfolioNeighborhoodId = Branded<
  string,
  typeof portfolioNeighborhoodIdBrand
>
export const mkPortfolioNeighborhoodId = (id: string): TPortfolioNeighborhoodId =>
  brand<TPortfolioNeighborhoodId>(id)
declare const portfolioNeighborhoodIdBrand: unique symbol
